/**
 * Fetch remediation documents (arbitium_remediations) by threat_event_id.
 */

import { fetchRing } from '../core';
import type { RemediationItem } from './create_remediation';

const RING_REMEDIATIONS = 'arbitium_remediations';

/**
 * Returns the first remediation document matching a given threat_event_id, or null if not found.
 * Fetches all records and filters client-side.
 */
export async function getRemediationByThreatEventId(
  threatEventId: string
): Promise<RemediationItem | null> {
  const res = await fetchRing<RemediationItem>(RING_REMEDIATIONS, { all: true });
  const items = Array.isArray(res.items) ? res.items : [];
  return items.find((item) => item.threat_event_id === threatEventId) ?? null;
}
